export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8066.07ac89ea.jpg";